// extracted by mini-css-extract-plugin
export default {"selectCardContainer":"selectCardContainer__LMua-","selectCard":"selectCard__ZmL3A"};